<span
    class="ar-tag"
    [class.ar-tag-generic]="type === 'generic'"
    [class.ar-tag-client]="type === 'client'"
>
    <ng-container *ngIf="type === 'client'; else generic">Client<ng-container *ngIf="accountName"> · {{ accountName }}</ng-container></ng-container>
    <ng-template #generic>Generic</ng-template>
</span>
